import type { VoidFunctionComponent } from 'react';

/**
 * Determine the textual range of items displayed on the current page.
 *
 * @param page Current page of visible items
 * @param count Number of items visible per page
 * @param totalItems Total number of items available
 * @returns Text representing the range of currently visible items
 */
const determinePageRange = (page: number, count: number, totalItems: number): string => {
  if (totalItems === 0) {
    return '';
  }

  // If there are less items than the page size,
  // it doesn't make sense to calculate + display a range.
  if (totalItems < count) {
    return `1 - ${totalItems}`;
  }

  const rangeStart = ((page - 1) * count) + 1;
  const rangeEnd = count * page;

  return `${rangeStart.toLocaleString()} - ${Math.min(rangeEnd, totalItems).toLocaleString()} of ${totalItems.toLocaleString()}`;
};

type Props = {
  //  Current page of visible items
  page: number,
  //  Number of items visible per page
  count: number,
  //  Total number of items available
  totalItems: number,
};

const PaginationRange: VoidFunctionComponent<Props> = ({
  page,
  count,
  totalItems,
}) => {
  const pageRange = determinePageRange(page, count, totalItems);

  return (
    <div className="fossa-page-range">
      {pageRange}
    </div>
  );
};

export default PaginationRange;
